const TRANSLATIONS = {
  'username: This value is already used.': 'Gebruikersnaam is al in gebruik.',
};

const getTranslation = (key) => TRANSLATIONS[key] || key;

export default getTranslation;
